import { useEffect, useRef, useState } from 'react'
import styled, { css } from 'styled-components'
import http from '../../../../../core/http-common'

// types
interface IDoctorPhotoProps {
  employeeId?: number
  doctorId: number
  IsAbsolute?: boolean
  size?: [number, number]
}

interface IPhotoProps {
  backgroundImageUrl: string
  IsAbsolute: boolean
  size: [number, number]
}

export default function DoctorPhoto({ employeeId, doctorId, IsAbsolute = true, size = [50, 50] }: IDoctorPhotoProps) {
  const [photoUrl, setPhotoUrl] = useState<string>('')
  const cancelledRef = useRef(false)

  useEffect(() => {
    cancelledRef.current = false
    const endpoint = !!employeeId
      ? `Employee/GetEmployeePhotoBase64String?employeeId=${employeeId}`
      : `Doctor/GetDoctorPhotoBase64String?doctorId=${doctorId}`

    http.get<string>(endpoint)
      .then((response) => {
        if (!cancelledRef.current && response.data) {
          setPhotoUrl(`data:image/png;base64,${response.data}`)
        }
      })
      .catch(() => {
        // Photo not available, leave empty
      })

    return () => { cancelledRef.current = true }
  }, [employeeId, doctorId])

  return <Photo IsAbsolute={IsAbsolute} size={size} backgroundImageUrl={photoUrl} />
}

const Photo = styled.div<IPhotoProps>`
  ${({ IsAbsolute }) =>
    IsAbsolute &&
    css`
      position: absolute;
      top: 25px;
      left: 125px;
      border: 2px solid #fff;
    `}
  background-image: ${({ backgroundImageUrl }) => `url(${backgroundImageUrl})`};
  width: ${({ size }) => `${size[0]}px`};
  height: ${({ size }) => `${size[1]}px`};
  background-size: cover;
  background-position: center center;
  border-radius: 50%;
  border: 1px solid #ccc;
`
